// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Scrollspy } from 'react-scrollspy';
import { startsWith } from 'lodash';
import { push } from 'react-router-redux';

@connect((store) => ({
  path: store.routing.locationBeforeTransitions.pathname
}), {
  push
})
export default class NavigationSidebar extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    links: PropTypes.array.isRequired,
    title: PropTypes.string,
    location: PropTypes.object,
    path: PropTypes.string.isRequired,
    push: PropTypes.func.isRequired
  }
  
  constructor(props, context) {
    super(props, context);
  }

  match(path, link) {
      if(link.exactMatch) {
       return path === link.href ? 'active' : null;
      }else {
        return startsWith(path, link.href) ? 'active' : null;
      }
  }
  render() {
    return (
      <div className='navigation-sidebar'>
        <h3>{this.props.title}</h3>
        <Scrollspy items={this.props.links}>
          {
            this.props.links.map((link) =>
              <li className={this.match(this.props.path, link)}>
                <a onClick={() => this.props.push(link.href)}><div className='label'>{link.title}</div></a>
              </li>
            )
          }
        </Scrollspy>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/NavigationSidebar/index.js